import {createSortable} from '@/utils'
export default {
  watch: {
    dataTable (newVal = []) {
      if (this.disabledDrag || !newVal.length) return
      if (!this.sortableInstance) {
        this._el = document.querySelector(`.${this.uniClass} .ivu-table-tbody`)
        this._el.style.cursor = 'pointer'
        this.sortableInstance = createSortable(this._el, {
          handle: `.${this.sortableHandle}`,
          filter: '.ivu-input',
          preventOnFilter: false,
          onMove: (evt, origin) => {
            let idx = this.findIndex(evt.from, evt.dragged)
            let item, dragFlag = !idx || (!this.noSearch && idx === 1)
            if (dragFlag) return false
            item = this.dataTable[idx - 1]
            if (item._isAdd) return false
          },
          onEnd: (evt) => {
            if (evt.newIndex === evt.oldIndex) return
            //兼容provide传值
            this.setSortIndex(evt.oldIndex, evt.newIndex + 1, this.dataTable[evt.oldIndex], this.dataTable[evt.newIndex])
            //兼容$on传值
            this.$emit('setSortIndex', {
              index: evt.oldIndex,
              value: evt.newIndex + 1,
              row: this.dataTable[evt.oldIndex],
              target: this.dataTable[evt.newIndex]
            })
            // 采用的是插入机制而不是交换，so改一下逻辑
            // 源数据移除队列
            let origin = this.dataTable[evt.oldIndex]
            this.dataTable.splice(evt.oldIndex, 1)
            // 插入队列
            this.dataTable.splice(evt.newIndex, 0, origin)
            // [this.dataTable[evt.oldIndex], this.dataTable[evt.newIndex]] = [this.dataTable[evt.newIndex], this.dataTable[evt.oldIndex]]
            this.data = []
            let data = this.dataTable
            this.$nextTick(() => {
              this.data = Object.assign([], data)
            })
          }
        })
      }
    }
    // dataTable (newVal = []) {
    //   this.sortableInstance = false
    //   this.sortQueue = []
    //   this.$nextTick(() => {
    //     if (this.disabledDrag || !newVal.length) return
    //     if (!this.sortableInstance) {
    //       this._elList = document.querySelectorAll(this.sortQuerySelector || `.${this.uniClass} .ivu-table-tbody`) || []
    //       this._elList.forEach(el => {
    //         el.style.cursor = 'pointer'
    //         let sortableInstance = createSortable(el, Object.assign({
    //           handle: `.${this.sortableHandle}`,
    //           filter: '.ivu-input',
    //           preventOnFilter: false,
    //           onMove: (evt, origin) => {
    //             let idx = this.findIndex(evt.from, evt.dragged)
    //             let item, dragFlag = idx === void 0 || (!this.noSearch && idx === 1)
    //             if (dragFlag) return false
    //             item = this.dataTable[Math.max(idx - 1, 0)]
    //             if (item._isAdd) return false
    //           },
    //           onEnd: (evt) => {
    //             if (evt.newIndex === evt.oldIndex) return
    //             //兼容provide传值
    //             this.setSortIndex(evt.oldIndex, evt.newIndex + 1, this.dataTable[evt.oldIndex])
    //             //兼容$on传值
    //             this.$emit('setSortIndex', {
    //               index: evt.oldIndex,
    //               value: evt.newIndex + 1,
    //               row: this.dataTable[evt.oldIndex]
    //             })
    //           }
    //         }, this.sortableConfig))
    //         this.sortQueue.push(sortableInstance)
    //       })
    //     }
    //   })
    // }
  },
  methods: {
    findIndex (paernts, child) {
      let children = paernts.children
      let findIdx
      if (!children || !children.length) return
      [...children].some((item, index) => {
        if (item === child) {
          findIdx = index
          return true
        }
      })
      return findIdx
    }
  }
}
